module.exports = __webpack_public_path__ + "img/40_69_014_030.f877107f.jpg";